// Estados e regiões do Brasil, na mesma divisão que o backend usa para agrupar
// os relatórios (backend: utils/Localidades.js). O filtro de estado envia a
// SIGLA; o nome serve só para exibir.
export const REGIOES = ['Norte', 'Nordeste', 'Centro-Oeste', 'Sudeste', 'Sul'];

export const ESTADOS_UF = [
  ['AC', 'Acre', 'Norte'], ['AP', 'Amapá', 'Norte'], ['AM', 'Amazonas', 'Norte'],
  ['PA', 'Pará', 'Norte'], ['RO', 'Rondônia', 'Norte'], ['RR', 'Roraima', 'Norte'],
  ['TO', 'Tocantins', 'Norte'],
  ['AL', 'Alagoas', 'Nordeste'], ['BA', 'Bahia', 'Nordeste'], ['CE', 'Ceará', 'Nordeste'],
  ['MA', 'Maranhão', 'Nordeste'], ['PB', 'Paraíba', 'Nordeste'], ['PE', 'Pernambuco', 'Nordeste'],
  ['PI', 'Piauí', 'Nordeste'], ['RN', 'Rio Grande do Norte', 'Nordeste'], ['SE', 'Sergipe', 'Nordeste'],
  ['DF', 'Distrito Federal', 'Centro-Oeste'], ['GO', 'Goiás', 'Centro-Oeste'],
  ['MT', 'Mato Grosso', 'Centro-Oeste'], ['MS', 'Mato Grosso do Sul', 'Centro-Oeste'],
  ['ES', 'Espírito Santo', 'Sudeste'], ['MG', 'Minas Gerais', 'Sudeste'],
  ['RJ', 'Rio de Janeiro', 'Sudeste'], ['SP', 'São Paulo', 'Sudeste'],
  ['PR', 'Paraná', 'Sul'], ['RS', 'Rio Grande do Sul', 'Sul'], ['SC', 'Santa Catarina', 'Sul'],
].map(([uf, nome, regiao]) => ({ uf, nome, regiao }));

export const estadosDaRegiao = (regiao) =>
  regiao ? ESTADOS_UF.filter((e) => e.regiao === regiao) : ESTADOS_UF;
